
import { defineComponent, PropType } from 'vue'
import { AutofixInstallationStatus, Repository } from '~/types/types'

export default defineComponent({
  name: 'RepoAutofixSettings',
  props: {
    autofixInstallationStatus: {
      type: String as PropType<Repository['autofixInstallationStatus']>,
      default: AutofixInstallationStatus.NotInstalled
    },
    autofixInstallationUrl: {
      type: String as PropType<Repository['autofixInstallationUrl']>,
      default: ''
    }
  },
  emits: {
    'show-install-autofix-modal': null
  },
  computed: {
    autofixSettingsInfo() {
      if (this.autofixInstallationStatus === AutofixInstallationStatus.NoPermission) {
        return {
          alertText:
            'The Autofix app has been installed but does not have all the necessary permissions.',
          bgColor: 'bg-honey',
          color: 'text-honey-400',
          description:
            'To use Autofix on this repository, DeepSource needs the necessary permissions to automatically create pull-requests.',
          pillBgColor: 'bg-honey-500'
        }
      }

      if (this.autofixInstallationStatus === AutofixInstallationStatus.Installed) {
        return {
          alertText:
            'The Autofix app has been installed and has all the necessary permissions on this repository.',
          bgColor: 'bg-juniper',
          color: 'text-juniper-300',
          description:
            'To use Autofix on this repository, DeepSource needs the necessary permissions to automatically create pull-requests.', // TODO: Confirm copytext
          pillBgColor: 'bg-juniper-500'
        }
      }

      return {
        alertText: 'The Autofix app has not been installed yet.',
        bgColor: 'bg-robin',
        color: 'text-robin-400',
        description:
          'To use Autofix on this repository, DeepSource needs the necessary permissions to automatically create pull-requests.',
        pillBgColor: 'bg-robin-500'
      }
    },
    autofixIsNotInstalled() {
      return this.autofixInstallationStatus === AutofixInstallationStatus.NotInstalled
    }
  }
})
